function getApiBase(): string {
  if (process.env.REACT_APP_API_BASE) return process.env.REACT_APP_API_BASE;
  if (process.env.REACT_APP_BACKEND_URL)
    return `${process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "")}/api/v0`;
  if (typeof window !== "undefined" && window.location.origin && !window.location.origin.includes("localhost"))
    return `${window.location.origin}/api/v0`;
  return "http://localhost:8001/api/v0";
}
const API_BASE = getApiBase();

export async function apiFetch<T>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const url = `${API_BASE.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
  const res = await fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
  if (!res.ok) {
    const err = new Error(`API error: ${res.status} ${res.statusText}`) as Error & { status: number };
    err.status = res.status;
    throw err;
  }
  const text = await res.text();
  if (!text) return undefined as T;
  return JSON.parse(text) as T;
}
